<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav class="hideOnPrint"/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                        :headers="headers"
                        :items="incidents"
                        sort-by="IncidentDateTimeTable"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Incident Reports"
                        :search="search"
                        height="550"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Incident Reports</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="desktop"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn
                                    fab
                                    small
                                    @click="printTable()"
                                    class="mr-8 mb-2 white--text"
                                    color="#2b6993"
                                    elevation="4"
                                >
                                    <v-icon>print</v-icon>
                                </v-btn>
                                    <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" @click="showAdd()">
                                        <v-icon left>add</v-icon>
                                        Add Incident Report
                                    </v-btn>
                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="mobile ml-5 mr-5 mb-3 mt-3"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <span v-if="item.Document != null">
                                <v-icon small class="mr-2" @click="downloadDocument(item)">
                                    mdi-download
                                </v-icon>
                            </span>

                            <v-icon small class="mr-2" @click="viewIncident(item)">
                                mdi-eye
                            </v-icon>
                            <!-- <v-icon small class="mr-2" @click="editIncident(item)">
                                mdi-pencil
                            </v-icon> -->
                            <v-icon v-if="!isAuditorRole" small @click="deleteIncident(item)">
                                mdi-delete
                            </v-icon>
                            <!-- <v-icon small @click="addDeal(item)">
                                add
                            </v-icon> -->
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="#2b3990" class="white--text" @click="getIncidents()">Reset</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <div id="printTable">
            <h2 class="text-center ma-3">Incident Reports</h2>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="incidents"
                        sort-by="IncidentDateTimeTable"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Incident Reports"
                        :search="search"
                        height="auto"
                        hide-default-footer
                        disable-pagination
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Incident Reports</v-toolbar-title>
                            </v-toolbar>

                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>


    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import renameFileHelper from '../../mixins/renameFileHelper'
import DateTimeUtil from '../../../utils/date-time.util.js';
import Swal from 'sweetalert2';

const FileSaver = require('file-saver');
const IncidentService = require('../../service/incident.service');


const url = require("../../client_config/config").url;

export default {
    mixins: [renameFileHelper],
    components: {
        ClientNav,
        ClientSide,
        Foot,
    },
    data() {
        return {
            headers: [
                {
                    text: 'Incident Category',
                    align: 'start',
                    sortable: true,
                    value: 'Type',
                },
                {text: "Incident Date and Approximate Time", value: "IncidentDateTimeTable"},
                {text: "Program", value: "Program"},
                {text: "Incident Location", value: "IncidentLocation"},
                {text: "DSPD/OL Notification Submitted", value: "ReportSubmitted"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            incidents: [],
            units: [],
            users: [],
            msg: false,
            text: "",
            search: "",
            clientID: this.$route.params.clientID,
            userState: localStorage.getItem('userState'),
            isLoading: true,
            page: 1,
            pageCount: 1,
            itemCount: 0,
            options: {},
        }
    },

    computed: {

        queryParams() {
            let {page, sortBy, sortDesc, itemsPerPage} = this.options;      
            const sortField = sortBy ? sortBy[0] : 'Date';
            const sortDirection = sortDesc ? sortDesc[0] : 'desc';

            return {
                    page: page || 1,
                    limit: itemsPerPage || 10,
                    search: this.search,
                    sortField: sortField,
                    sortDirection: sortDirection,
                };
        },
        clientName() {
            // `this` points to the component instance
            return this.$store.state.clients.client.Name;
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {
        search: {
            handler() {
                this.getIncidents();
            },
            immediate: true,
        },
        options: {
            handler() {
                this.getIncidents();
            },
            deep: true
        },

        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.getIncidents();
        let incidentId = this.$route.query.view;

        if (incidentId) {
            IncidentService.getById(incidentId).then((response) => {
                this.viewIncident(response.data.incident);
            })
        }
    },

    methods: {
        initialize() {
            this.incidents = [];
        },

        showAdd() {
            this.$router.push({
                path: `/incidents/${this.clientID}/add-incident`,
                query: { newIncident: 'true' }
            });
        },

        viewIncident(item) {
            this.$router.push({
                path: `/incidents/${this.clientID}/update-incident/${item._id}`,
                query: { newIncident: 'false' }
            });
        },

        deleteIncident(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this incident?") &&
            this.incidentDelete(id);
        },

        downloadDocument(item) {
            if (item.Document) {
                let documentName = item.Document?.Name || '';
                let documentLink = item.Document?.AWSLink || '';
                FileSaver.saveAs(documentLink, documentName);
            } else {
                alert("No document is attached.");
            }
        },

        incidentDelete(id) {
            Swal.fire({
                title: 'Please wait...',
                text: 'Deleting incident...',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });

            axios.delete(`${url}/incidents/${id}`)
                .then((response) => {
                    Swal.close();
                    this.getIncidents();
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            Swal.fire({
                                title: 'Error!',
                                text: data.msg,
                                icon: 'error',
                                confirmButtonText: 'OK'
                            });
                        });
                    } else {
                        Swal.fire({
                            title: 'Deleted!',
                            text: 'The incident has been deleted successfully.',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });
                    }
                })
                .catch((error) => {
                    let errorMessage = 'An error occurred while deleting the incident.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    } else if (error.message) {
                        errorMessage = error.message;
                    }
                    Swal.fire({
                        title: 'Error!',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                });
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.clearFields()
            });
        },

        getIncidents() {
            this.isLoading = true;
            let params = this.queryParams;
            axios.get(`${url}/incidents/client/${this.clientID}`, {params}).then(response => {

                const {docs, totalPages, totalDocs} = response.data;

                this.incidents = docs.map(incident => ({
                    ...incident,
                    IncidentDateTimeTable: DateTimeUtil.toLocalDateTime(incident.IncidentDateTime)
                }));

                this.incidents.sort((a, b) => {
                    return new Date(b.IncidentDateTimeTable) - new Date(a.IncidentDateTimeTable);
                });

                this.pageCount = totalPages;
                this.itemCount = totalDocs;


                this.getUnits()
            }).finally(() => this.isLoading = false);
        },

        getUnits: function () {
            axios.get(`${url}/units/state/${this.userState}`).then(async res => {
                res.data.units.forEach(item => {
                    this.units.push(item.Name)
                })

            });
        },

        deleteChip(index) {
            // Prompt here with text if required
            this.newDocument.splice(index, 1);
        },

        downloadImage(photo) {
            window.location.href = photo;
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()

        },

        printItem() {
            document.getElementById('printTable').style.display = "none";
            window.print()
        },
    },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

.btn-filter {
    margin-top: 40px;
    margin-right: 50px;
}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;


    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}

</style>
